export default __webpack_public_path__ + "static/media/clouds.f457d578.png";